module.exports = __webpack_public_path__ + "img/shoppingmall_shopia.65ac1bab.png";